import { API_BASE_URL } from './api';
import { authService } from './authService';

export const inviteService = {
  /** Tells the server who invited the (brand-new) caller. Idempotent; a no-op for accounts older than a day. */
  redeem: async (inviterUserId: string): Promise<{ redeemed: boolean }> => {
    const res = await fetch(`${API_BASE_URL}/invites/redeem`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authService.getAuthHeaders() },
      body: JSON.stringify({ inviterUserId }),
    });
    if (!res.ok) throw new Error('Failed to redeem invite');
    return res.json();
  },
};
